import * as ReactNativeWeb from 'react-native-web';

const noop = () => {};

const ActionSheetIOS = {
  showActionSheetWithOptions: (_options = {}, callback = noop) => {
    try {
      callback(0);
    } catch (error) {
      noop(error);
    }
  },
  showShareActionSheetWithOptions: (
    _options = {},
    failureCallback = noop,
    successCallback = noop
  ) => {
    try {
      successCallback(true, 0);
    } catch (error) {
      failureCallback(error, false);
    }
  },
};

const granted = "granted";
const denied = "denied";
const neverAskAgain = "never_ask_again";

const PermissionsAndroid = {
  RESULTS: {
    GRANTED: granted,
    DENIED: denied,
    NEVER_ASK_AGAIN: neverAskAgain,
  },
  PERMISSIONS: {
    CAMERA: "camera",
    BLUETOOTH_SCAN: "bluetooth_scan",
    BLUETOOTH_CONNECT: "bluetooth_connect",
    ACCESS_FINE_LOCATION: "access_fine_location",
  },
  check: async () => granted,
  request: async () => granted,
  requestMultiple: async () => ({
    camera: granted,
    bluetooth_scan: granted,
    bluetooth_connect: granted,
    access_fine_location: granted,
  }),
};

export * from 'react-native-web';
export { ActionSheetIOS, PermissionsAndroid };

export default ReactNativeWeb;
